import React from 'react'
import i18next from 'i18next'
import { copyButtonIconColour } from 'styles/theme/colours'
import { CopyButton } from '@node-space/storybook-components/dist/CopyButton'
import { Box, Text } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

interface SidePanelCopyRowProps {
  label: string
  content: string
}

export const SidePanelCopyRow = ({ label, content }: SidePanelCopyRowProps) => {
  return (
    <Box flex justify="between" gapX={16}>
      <Text color="subdued">{label}</Text>
      <Box flex className="text-end">
        <Text tag="span" variant="body-label" className="md:justify-end md:text-right break-all">
          {ellipseMiddleText(content, 20, 10)}
        </Text>
        <CopyButton
          copyText={content}
          confirmationMessage={i18next.t('copiedToClipboard')}
          iconColour={copyButtonIconColour}
          confirmationMessageAlignment="left"
          confirmationMessageTheme="dark"
        />
      </Box>
    </Box>
  )
}
